// extracted by mini-css-extract-plugin
export var hideEditor = "_k4-2";
export var infoIcon = "_k4-3";
export var label = "_k4-1";
export var labelContainer = "_k4-0";
export var readonlyText = "_k4-4";